import classNames from "classnames";
import {CyClass} from "../../../../common/cy-classes";
import {useServices} from "../../../react-hooks/use-services.hook";
import {withServices} from "../../../react-hooks/with-services";
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {GenericSideMenuItemIconBox} from "../../side-menu-rework/side-menu-items/boxes/link/generic/generic-side-menu-item-icon.box"
import {MobileMenuItemContainerBox} from "../boxes/mobile-menu-item-container.box"
import {MobileMenuItemLinkBox} from "../boxes/mobile-menu-item-link.box";


export const ComponentBody = (props: ComponentServicesPick<'sideMenu'>) => {
    const services = useServices();

    const SettingsIcon = services.theme.currentTheme.icons.sideMenuSettingsIcon;
    const RightArrowIcon = services.theme.currentTheme.icons.rightArrowIcon;

    return (
        <MobileMenuItemContainerBox
            className={classNames(CyClass('cy-menu-item'), CyClass('cy-mobile-client-settings-trigger'))}
            onClick={props.sideMenu.openMobileClientSettings}
        >
            <GenericSideMenuItemIconBox>
                <SettingsIcon size={2} />
            </GenericSideMenuItemIconBox>
            <MobileMenuItemLinkBox className="cy-settings-mobile-item">
                {services.translation.translate("SETTINGS")}
            </MobileMenuItemLinkBox>
            <RightArrowIcon size={1} />
        </MobileMenuItemContainerBox>
    )
}


export const MobileClientSettingsMenuItemComponent = withServices(ComponentBody, ['sideMenu']);